import apiFetch from '../apiFetch'

export default function (idInstalacion, token) {
  return apiFetch({endPoint: `Instalacion/getInstalacion?idInstalacion=${idInstalacion}`, method: 'GET', body: null, token: token})
}
